import { useEffect } from 'react'
import { Flex } from '@chakra-ui/react'
import { addDays, format, parse } from 'date-fns'

import { useCustomFormViewer } from '../../../contexts/CustomFormViewerManager/Provider'
import CustomFormViewerQuestion from '../../../components/CustomFormViewerQuestion'

export default function LicencaPaternidadeMedicosCLT() {
  const { questions, formMethods } = useCustomFormViewer()
  const { watch, setValue } = formMethods

  const titleForQuestion = Object.fromEntries(questions.map((q) => [q.title, q.slug]))

  const inicioDoAfastamento = watch
    ? watch(`form_answers.${titleForQuestion['Data de início do afastamento']}`)
    : undefined
  const numeroDeDiasDeAtestado = watch
    ? watch(`form_answers.${titleForQuestion['Quantidade de dias de afastamento']}`)
    : undefined

  useEffect(() => {
    if (inicioDoAfastamento && !isNaN(numeroDeDiasDeAtestado)) {
      try {
        const parsedDate = parse(inicioDoAfastamento, 'dd/MM/yyyy', new Date())
        const finalDate =
          numeroDeDiasDeAtestado == ''
            ? addDays(parsedDate, Number(numeroDeDiasDeAtestado))
            : addDays(parsedDate, Number(numeroDeDiasDeAtestado) - 1)
        const formatted = format(finalDate, 'dd/MM/yyyy')

        setValue(`form_answers.${titleForQuestion['Data final do afastamento']}`, formatted)
      } catch (err) {
        // Data inválida
        setValue(`form_answers.${titleForQuestion['Data final do afastamento']}`, '')
      }
    }
  }, [inicioDoAfastamento, numeroDeDiasDeAtestado, setValue])

  if (!questions) return null

  return (
    <Flex bg="transparent" flexDir="column" gap={2} borderTop="1px solid" borderColor="primary">
      {questions.map((question, index) => {
        return (
          <CustomFormViewerQuestion
            key={index}
            index={index}
            questionsLength={questions.length}
            question={question}
            disabled={false}
          />
        )
      })}
    </Flex>
  )
}
